import "../../icons/atalanda.icon_font";
import "../../fonts/atalanda/fonts.scss";
import "../../fonts/global/fonts.scss";
import "../../store";
